export const SET_TRU_VALIDATE_BLACKBOX = 'SET_TRU_VALIDATE_BLACKBOX'

const initialState = {
  loggedIn: false,
  FIRST_NAME: "",
  MIDDLE_NAME: "",
  LAST_NAME: "",
  ORG_NAME: "",
  USERNAME: "",
  PHONE: "",
  BUSINESS_NAME: "",
  ADDR1: "",
  ADDR2: "",
  ADDR3: "",
  CITY: "",
  STATE: "",
  POSTAL_CODE: "",
  COUNTRY: "",
  EMAIL: "",
  WEB_USER_ID: 0,
  USER_GROUP: 'PUBLIC',
  isFrequentPayor: false,
  checkingAuthState: false,
  expires: null,
  initialAuthCheck: true,
  truValidateRequest: { BlackBox: null },
}

const AuthReducer = (state=initialState, action) => {
  switch (action.type) {
    case "SET_AUTH_ATTRIBUTE":
      return {...state, [action.attribute]: action.value}
    case "SPREAD_AUTH_ATTRIBUTES":
      return {...state, ...action.payload}
    case "CLEAR_USER":
      return {...state, ...initialState, initialAuthCheck: false}
    case "TOGGLE_LOGGED_IN":
      return {...state, loggedIn: action.loggedIn}
    case "SET_EXPIRATION":
      return {...state, expires: action.expires}
    case SET_TRU_VALIDATE_BLACKBOX:
      return {
        ...state,
        truValidateRequest: { BlackBox: action.blackbox.blackbox },
      }
    default:
      return state
  }
}

export default AuthReducer;



// WEBPACK FOOTER //
// ./src/Auth/AuthReducer.js